"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapKapiToDisplay = exports.isOnboarding = exports.isBeforeSupplyStart = exports.dummyGasRegister = exports.BACKUP_STARTDATE = void 0;
var date_fns_1 = require("date-fns");
var date_fns_tz_1 = require("date-fns-tz");
var constants_1 = require("../../../../shared/api/fixtures/meter-readings/shared/constants");
var __generated__1 = require("../../../../shared/api/kapi/v1/__generated__/");
var constants_2 = require("../../constants");
var utils_1 = require("../../utils");
var reads_config_1 = require("../../utils/reads-config");
var mapKapiReadings_1 = require("./mapKapiReadings");
var INVALID_DATE_ERROR = 'Invalid date';
exports.BACKUP_STARTDATE = new Date('1990-01-01');
exports.dummyGasRegister = {
    registerId: 'gas',
    timeOfUseLabel: null,
    startDate: exports.BACKUP_STARTDATE,
    endDate: null,
};
var dummyOpeningRegister = {
    registerId: '0',
    timeOfUseLabel: 'anytime',
    startDate: exports.BACKUP_STARTDATE,
    endDate: null,
};
var dummyOpeningMeterInfo = {
    msn: 'Unknown',
    meterNumOfDigits: undefined,
    rawMeterType: constants_1.universalTradMeterType,
    registers: [dummyOpeningRegister],
    meterStatus: 'active',
};
var validateStartDate = function (date) {
    var startDate = new Date(date);
    if (startDate.toString() === 'Invalid Date') {
        throw new Error(INVALID_DATE_ERROR);
    }
    return date;
};
var isSupplyPointInfoValid = function (meter) { return !!meter.msn; };
var isBeforeSupplyStart = function (supplyStartDate) {
    return (0, date_fns_1.isBefore)((0, date_fns_1.startOfToday)(), supplyStartDate);
};
exports.isBeforeSupplyStart = isBeforeSupplyStart;
var isActive = function (endDate, meterStatus) {
    return endDate ? (0, date_fns_1.isAfter)(endDate, (0, date_fns_1.endOfToday)()) : true && meterStatus !== 'removed';
};
var isMultiRate = function (meter) { return meter.registers.length > 1; };
// Is today less than 6 days after supply start date?
var isOnboarding = function (supplyStartDate) {
    return (0, date_fns_1.isBefore)((0, date_fns_1.startOfToday)(), (0, date_fns_1.addDays)(new Date(supplyStartDate), constants_2.ONBOARDING_DAYS));
};
exports.isOnboarding = isOnboarding;
var hasIndustryOpeningRead = function (meter, readings) {
    return (0, utils_1.hasExpectedReadings)(readings, meter.registers, [
        'OpeningReadingActual',
        'OpeningReadingDeemed',
    ]);
};
var hasIndustryActualReadIn12Months = function (meter, readings) {
    return (0, utils_1.hasExpectedReadings)((0, utils_1.getReadingsAfter)(readings, (0, date_fns_1.subYears)((0, date_fns_1.startOfToday)(), 1)), meter.registers, [
        'OpeningReadingDeemed',
        'OnSiteReading',
        'OpeningReadingActual',
        'FinalReadingActual',
        'MeterConfigChangeFinal',
        'MeterConfigChangeInitial',
        'MexReadingInitial',
        'MexReadingFinal',
    ]);
};
//Assumes all registers on a meter have the same digits
var getMeterNumOfDigits = function (meterTechnicalDetail) {
    var _a;
    if (meterTechnicalDetail.registers.length > 0) {
        return parseInt((_a = meterTechnicalDetail.registers[0].numberOfDigits) !== null && _a !== void 0 ? _a : '0');
    }
    return 0;
};
var rawMeterType = function (meterTechnicalDetail) { var _a; return (_a = meterTechnicalDetail.type) !== null && _a !== void 0 ? _a : undefined; };
var mapRegisters = function (meterTechnicalDetail, fuel, timezone) {
    return meterTechnicalDetail.registers.map(function (register) {
        return fuel === 'electricity'
            ? {
                registerId: register.registerId,
                timeOfUseLabel: (0, utils_1.timingCategoryToTimeOfUseLabel)(register.timingCategory),
                startDate: register.registerStartDate
                    ? (0, date_fns_tz_1.toZonedTime)(register.registerStartDate, timezone)
                    : exports.BACKUP_STARTDATE,
                endDate: register.registerEndDate
                    ? (0, date_fns_tz_1.toZonedTime)(register.registerEndDate, timezone)
                    : null,
            }
            : exports.dummyGasRegister;
    });
};
var supplyStates = function (meter, supplyPoint, readings) {
    var _a;
    var isSmart = (0, utils_1.isSmartSupply)((_a = meter.rawMeterType) !== null && _a !== void 0 ? _a : '');
    return {
        isSupplyPointInfoValid: isSupplyPointInfoValid(meter),
        isActive: isActive(supplyPoint.endDate, meter.meterStatus),
        isBeforeSupplyStart: (0, exports.isBeforeSupplyStart)(supplyPoint.startDate),
        showSimplifiedLabels: !isMultiRate(meter),
        //Smart
        isSmart: isSmart,
        //Onboarding
        isOnboarding: (0, exports.isOnboarding)(supplyPoint.startDate),
        //Regulatory information
        isNonComms: (0, utils_1.isNonCommsMeter)(isSmart, readings),
        hasIndustryOpeningRead: hasIndustryOpeningRead(meter, readings),
        hasIndustryActualReadIn12Months: hasIndustryActualReadIn12Months(meter, readings),
    };
};
var confirmReadsExist = function (accountSupplyPoint) {
    return accountSupplyPoint.meterReads.edges;
};
var mapSupplyFuelToFuelType = function (supplyFuel) {
    switch (supplyFuel) {
        case __generated__1.SupplyFuel.Electricity:
            return 'electricity';
        case __generated__1.SupplyFuel.Gas:
            return 'gas';
    }
};
function mapKapiToDisplay(data) {
    var _a;
    var supplies = ((_a = data.account.accountSupplyPoints) !== null && _a !== void 0 ? _a : [])
        .filter(confirmReadsExist)
        .flatMap(function (asp) {
        var _a, _b;
        var supplyPoint = asp.supplyPoint;
        var supplyPointInfo = {
            sprn: supplyPoint.sprn,
            timezone: supplyPoint.timezone,
            startDate: validateStartDate(asp.startDate),
            endDate: (_b = (_a = asp.end) === null || _a === void 0 ? void 0 : _a.date) !== null && _b !== void 0 ? _b : undefined,
            fuel: mapSupplyFuelToFuelType(asp.supplyPoint.fuelType),
        };
        var meterInfos = asp.supplyPoint.meterTechnicalDetails.map(function (meterTechnicalDetail) { return ({
            msn: meterTechnicalDetail.meterSerialNumber,
            meterNumOfDigits: getMeterNumOfDigits(meterTechnicalDetail),
            rawMeterType: rawMeterType(meterTechnicalDetail),
            registers: mapRegisters(meterTechnicalDetail, supplyPointInfo.fuel, supplyPointInfo.timezone),
            meterStatus: meterTechnicalDetail.status
                ? meterTechnicalDetail.status.toLowerCase()
                : 'active',
        }); });
        var reads = (0, mapKapiReadings_1.createValidMappedReads)(asp);
        if ((0, reads_config_1.readsConfig)('openingReadsFlow') &&
            (0, exports.isOnboarding)(supplyPointInfo.startDate) &&
            meterInfos.length === 0) {
            meterInfos.push(dummyOpeningMeterInfo);
        }
        return meterInfos.map(function (meterInfo) {
            var readsByMsn = reads.filter(function (read) { return read.msn === meterInfo.msn; });
            return __assign(__assign(__assign({}, supplyPointInfo), meterInfo), { states: supplyStates(meterInfo, supplyPointInfo, readsByMsn), readings: readsByMsn });
        });
    });
    var gasSupplies = supplies.filter(function (supply) { return supply.fuel === 'gas'; });
    var elecSupplies = supplies.filter(function (supply) { return supply.fuel === 'electricity'; });
    var elecSuppliesWithMultipleSuppliesFlagged = (0, utils_1.hasComplexElec)(elecSupplies)
        ? elecSupplies.map(function (supply) { return (__assign(__assign({}, supply), { states: __assign(__assign({}, supply.states), { showSimplifiedLabels: false }) })); })
        : elecSupplies;
    return {
        electricity: elecSuppliesWithMultipleSuppliesFlagged,
        gas: gasSupplies,
    };
}
exports.mapKapiToDisplay = mapKapiToDisplay;
